// extracted by mini-css-extract-plugin
export var discard = "_29-4";
export var muiTooltipTooltip = "_29-6";
export var notificationBar = "_29-3";
export var notificationContainer = "_29-2";
export var saveButtonHoverSlotWrapper = "_29-5";
export var show = "_29-1";
export var spacer = "_29-0";